// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1hflm","colMaxWidth":"Table_colMaxWidth__1zXsM"};